import { Controller } from "@hotwired/stimulus"
import { Datepicker } from "vanillajs-datepicker"

export default class extends Controller {
  static targets = [
    "campaignScheduleTimeStart",
    "campaignScheduleTimeEnd",
    "editAccountModal",
    "sendEmailAs",
    "smtpImapLink",
    "customStartdate",
    "customScheduleStartdate",
    "emailAccountIds",
    "campaignId",
    "emailAccountSelect",
    "bccRecipient",
  ]

  static get values() {
    return {
      earliestDate: String,
      campaignId: Number,
    }
  }

  initialize() {
    this.updateCampaignScheduleTimeIntervals()
    this.fetchAliasesOnEditModalOpen()
  }

  connect() {
    const connectSmtpParam = new URLSearchParams(location.search).get("connect_smtp")

    if (connectSmtpParam) {
      this.smtpImapLinkTarget.click()
    }

    if (this.hasCustomStartdateTarget) {
      this.customStartdate = new Datepicker(this.customStartdateTarget, {
        format: "yyyy-mm-dd",
        minDate: this.earliestDateValue,
        pickLevel: 0,
        prevArrow: "‹",
        nextArrow: "›",
        autohide: true,
      })
    }
  }

  // updateCampaignScheduleTimeIntervals disables some campaign schedule
  // time schedule options to prevent the user to select impossible intervals.
  updateCampaignScheduleTimeIntervals() {
    var _this = this

    $(`#${$(this.campaignScheduleTimeStartTarget).attr("id")} > option`).each(function () {
      if (parseInt(this.value) > parseInt($(_this.campaignScheduleTimeEndTarget).val())) {
        $(this).attr("disabled", "disabled")
      } else {
        $(this).removeAttr("disabled")
      }
    })

    $(`#${$(this.campaignScheduleTimeEndTarget).attr("id")} > option`).each(function () {
      if (parseInt(this.value) < parseInt($(_this.campaignScheduleTimeStartTarget).val())) {
        $(this).attr("disabled", "disabled")
      } else {
        $(this).removeAttr("disabled")
      }
    })
  }

  fetchAliasesOnEditModalOpen() {
    var _this = this

    this.editAccountModalTargets.forEach(function (target) {
      if ($(target).data("email-account-provider") === "gmail") {
        _this.fetchGmailAliases(target)
      }
    })
  }

  fetchGmailAliases(target) {
    var emailAccountId = $(target).data("email-account")
    var select = $(target).find(`select#email_account_send_email_as-${emailAccountId}`)

    fetch(`/email_accounts/${emailAccountId}/aliases`, { credentials: "same-origin" })
      .then((response) => response.json())
      .then((response) => {
        response.aliases.forEach(function (alias) {
          if ($(select).find(`option[value='${alias.send_as_email}']`).length === 0) {
            // append the alias only if it's not part of the options yet
            $(select).append(
              `<option value="${alias.send_as_email}" data-display-name="${alias.display_name}">${alias.send_as_email}</option>`,
            )
          }
        })

        if (response.aliases.length > 1) {
          document.getElementById(`email_account_alias_hint-${emailAccountId}`).classList.remove("d-none")
        } else {
          document.getElementById(`email_account_alias_hint-${emailAccountId}`).classList.add("d-none")
        }
      })
      .catch((error) => {
        console.error(`Failed to retrieve aliases from Gmail: ${error}`)
      })
  }

  updateDisplayName(e) {
    var newDisplayName = e.target.options[e.target.selectedIndex].dataset.displayName
    var emailAccount = e.target.dataset.emailAccount

    $(`#email_account_display_name-${emailAccount}`).val(newDisplayName)
  }

  toggleCustomStartdate(e) {
    if (e.target.checked) {
      this.customScheduleStartdateTarget.removeAttribute("hidden")
    } else {
      this.customScheduleStartdateTarget.setAttribute("hidden", true)
      this.customStartdate.element.value = null
    }
  }

  updateEmailAccountsSettings() {
    const bccRecipient = this.bccRecipientTarget.value
    const emailAccountIds = Array.from(
      this.element.querySelectorAll('input[name="outreach_settings[email_account_ids][]"]'),
    )
      .filter((input) => input.checked)
      .map((input) => input.value)

    const settings = {
      email_account_ids: emailAccountIds,
    }

    // Only include BCC if it was changed
    if (bccRecipient !== this.bccRecipientTarget.defaultValue) {
      settings.bcc_recipient = bccRecipient
    }

    this.saveCampaignSettings(settings)
  }

  saveCampaignSettings(settings) {
    fetch(`/campaigns/${this.campaignIdValue}/settings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({ outreach_settings: settings }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          App.displayFlash("danger", data.error)
        } else if (data.success) {
          App.displayFlash("success", data.success)
        }
      })
  }
}
